<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="invoices"
            :search="search"
            sort-by="calories"
            class="elevation-1"
            >
            <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Automatic MOD</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-btn @click="listInvoices()" color="primary" dark class="mb-2">Seach</v-btn>
                    <v-spacer></v-spacer>        
               <template>
                    <v-row justify="center">
                        <v-dialog v-model="dialog" persistent max-width="650px">
                        <template v-slot:activator="{ on }" >
                            <v-btn color="primary" dark v-on="on">New</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                           
                            <v-card-text>                            
                            <v-container>                              
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                </v-flex>   
                                <v-row>
                                   
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="project_name" label="Project Name" ></v-text-field>
                                    </v-col>
                                    
                                     <v-col cols="12" sm="6" md="6">
                                        <template>
                                        <v-file-input 
                                            v-model="file"                                     
                                            accept=".csv"
                                            placeholder="Select your file template"                                        
                                            label="File"
                                        ></v-file-input>
                                        </template>
                                     </v-col>
                                                                    
                                    
                                                                  
                                </v-row>                            
                            </v-container>
                            <small>*indicates required field</small>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>                            
                                <v-btn
                                    :disabled="dialogLoading"
                                    :loading="dialogLoading"
                                    color="blue darken-1" text @click="save"
                                    >
                                    Save
                                </v-btn>
                            
                           
                           <v-dialog
                                v-model="dialogLoading"
                                hide-overlay
                                persistent
                                width="300"
                                >
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text>
                                    Saving, please be patient.
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                                </v-dialog>
            



                            </v-card-actions>
                        </v-card>
                        </v-dialog>                   
                    </v-row>




                  <div id="app" style="height:100vh">
                    <v-container fill-height>
                <v-layout column>
      <v-flex style="background-color:red" fill-height>

                        <v-dialog v-model="dialogViewItems"  width="1450px"  >
                      
                        <v-card>  
                            <v-card-actions >
                                <v-spacer></v-spacer>
                                <v-btn  color="primary" text @click="dialogViewItems = false"> Close</v-btn>                            
                            </v-card-actions>  
                          <v-card-text>    
                                                
                                                         
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                   
                                   <template>
                                        <v-card>
                                            <v-card-title>
                                               Project: {{project_name}}
                                            <v-spacer></v-spacer>
                                            <v-text-field
                                                v-model="searchViewItem"
                                                append-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                            ></v-text-field>
                                            </v-card-title>
                                            <v-data-table
                                                :headers="headersViewItems"
                                                :items="viewItems"
                                                class="elevation-1"
                                                :search="searchViewItem"
                                                >
                                                
                                                <template v-slot:body="{ items }">
                                                    <tbody>
                                                        <tr v-for="item in items" :key="item.id_file_detail"> 
                                                           
                                                            <td class="text-xs-right">{{item.sequence}} </td>
                                                            <td class="text-xs-right"> 
                                                                <div v-if="item.pn_status == 'E'">
                                                                    <span class="orange--text"> {{item.result_msg}} </span>                                    
                                                                </div>
                                                                <div v-if="item.pn_status == 'B'">
                                                                    <span class="blue--text"> {{item.result_msg}} </span>                                    
                                                                </div>
                                                                <div v-if="item.pn_status == 'E1'">
                                                                    <span class="red--text"> {{item.result_msg}} </span>                                    
                                                                </div>
                                                                <div v-if="item.pn_status == 'E2'">
                                                                    <span class="red--text"> {{item.result_msg}} </span>                                    
                                                                </div>
                                                            </td>    
                                                            <td class="text-xs-right">{{item.pn_level}} </td>                                                                          
                                                            <td class="text-xs-right">{{item.part_number}} </td>   
                                                            <td class="text-xs-right">{{item.part_desc}} </td> 

                                                            <td class="text-xs-right">{{item.pn_qty}} </td>                                                                          
                                                            <td class="text-xs-right">{{item.part_rev}} </td>   
                                                            <td class="text-xs-right">{{item.platform}} </td>    
                                                            <td class="text-xs-right">{{item.region}} </td>
                                                                            
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-data-table>
                                        </v-card>
                                    </template>
                                  </v-flex>  

                            </v-card-text>
                           
                        </v-card>
                        </v-dialog> 

 </v-flex >
                        </v-layout >
                       
                    
                    </v-container>
                  </div>


                   

                </template>


                  
                           

               



            </v-toolbar>
        </template>
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.id_file_master">
                            <td>
                                <div >  
                                    <div v-if="!item.received ">                                  
                                        <v-icon small class="mr-2" @click="editItem(item)">
                                            edit
                                        </v-icon>
                                         <v-icon small class="mr-2" @click="viewListItem(item)">
                                            list
                                        </v-icon>
                                    </div>
                                </div>                                                                     
                            </td>                  
                                                        
                            <td class="text-xs-right">{{item.project_name}} </td>
                            <td class="text-xs-right">{{item.file_name}} </td>                            
                             <td class="text-xs-right">                                                        
                                <div v-if="item.status_file == 'O'">
                                    <span class="orange--text"> Open </span>                                    
                                </div>
                                <div v-if="item.status_file == 'E'">
                                    <span class="red--text"> Error </span>                                    
                                </div> 
                                <div v-if="item.status_file == 'C'">
                                    <span class="blue--text"> Close </span>                                    
                                </div> 
                                <div v-if="item.status_file == 'P'">
                                    <span class="blue--text"> Processing </span>                                    
                                </div> 
                            </td>
                            
                            <td class="text-xs-right">{{item.created_by}} </td>                             
                            <td class="text-xs-right">{{moment(item.create_date).format('MM/DD/YYYY')}} </td> 

                         

                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
    </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
   
    export default{
        components: {
                     
        },       
        data (){
            return {
                  moment:moment,                
                  invoices:[],
                 
                 searchViewItem: '',
                 viewItems:[], 
                 headersViewItems: [
                       { text: 'Sequence',  align: 'start', sortable: false,  value: 'sequence'  },
                       { text: 'Message',  align: 'start', sortable: false,  value: 'result_msg'  },
                        { text: 'Level',  align: 'start', sortable: false,  value: 'pn_level'  },
                        { text: 'Part Number',  align: 'start', sortable: false,  value: 'part_number'  },                        
                        { text: 'Description',  align: 'start', sortable: false,  value: 'part_desc'  },
                        { text: 'Qty',  align: 'start', sortable: false,  value: 'pn_qty'  },
                        { text: 'Revision',  align: 'start', sortable: false,  value: 'part_rev'  },
                        { text: 'Platform',  align: 'start', sortable: false,  value: 'platform'  },
                        { text: 'Region',  align: 'start', sortable: false,  value: 'region'  },                       
                        
                        
                    ],


                  dialog: false,
                  dialogViewItems: false,
                  dialogLoading: false,
                    headers: [
                        { text: 'Actions', value: 'action', sortable: false },                        
                       
                        { text: 'Project name', value: 'project_name', sortable: false },
                        { text: 'Filename', value: 'file_name', sortable: false },                        
                        { text: 'Status', value: 'status_file', sortable: false },
                        { text: 'Created by', value: 'created_by', sortable: false },
                        { text: 'Create date', value: 'create_date', sortable: false }                       
                                           
                        

                    ],
                    //moment: moment, // Set to whatever
                   
                    projectID_new:  0,
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                  
                    file: null,
                    
                    id: '', 
                    project_name: '', 
                    
                                      
                    creator : '', 
                    create_dt: '', 
                  
                   
                    valida:0,
                    validaMensaje:[]   
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Mod' : 'Edit Mod'
            },
                          
        },

        watch: {
            
            dialogViewItems (val) {
            val || this.close()
            } ,

            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();
            this.listInvoices();               
        },

         methods: {  
             exitApp(){
          this.$store.dispatch("exit");
        },      

         run_SAP(){
                axios.defaults.baseURL = this.$SAPAPI;  
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
               
                console.log('run_SAP ID = ' + me.projectID_new);               
                
                axios.post('api/ModDell',{
                    'projectID': me.projectID_new
                    }).then(function(response){                  
                    //me.materials = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },

            listInvoices(){
                this.run_SAP();
                axios.defaults.baseURL =  this.$hostname;
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='api/dell_d_mod_file_master/List';
                if (!me.search){
                    //url ='api/Invoices/List';
                }
                else{
                    //url ='api/Invoices/ListFilter/' + me.search;
                }
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.invoices = response.data;
                    //console.log( me.invoices);
                }).catch(function(error){
                    console.log(error);
                })
            },
            
            initialize () {                            
            },
            
            editItem (item) {
                                               
                this.id= item.id_file_master;  
                this.project_name= item.project_name;                                
                
                this.creator= 'RAFBEL';                

                this.editedIndex=1;
                this.dialog = true
            },

            viewListItem (item) {
                                               
                this.id= item.id_file_master;  
                this.project_name= item.project_name;

                this.viewItems =  item.fileDetails;  

                console.log( this.viewItems)  ;                           
                
                this.creator= 'RAFBEL';                

                this.editedIndex=1;
                this.dialogViewItems = true
            },



            deleteItem (item) {
                const index = this.desserts.indexOf(item)
                confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
            },

            close () {
                this.dialogViewItems = false;
                //this.this.viewItems = [];
                
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.id= ""; 
                this.project_name= "";    

                this.file= null;            
                            
                this.creator=  "";    

                this.editedIndex=-1;

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
            save () {               
                if (this.validar() > 0)  {                                      
                     return;   
                }                
                
                console.log(this.$store.state.user.userName);
                
                if (this.editedIndex > -1) {                   
                   //Code for Edit Mode
                  
                  axios.defaults.baseURL =  this.$hostname;
                  this.dialogLoading = true;

                  let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoading = true;   

                    me.projectID_new = me.id;

                    console.log('Update project: = ' + me.projectID_new);

                    let formData = new FormData();
                    formData.append("id_file_master", me.id);                   
                    formData.append("project_name", me.project_name);
                    formData.append("file_name", '');
                    formData.append("status_file", '');
                    formData.append("created_by", this.$store.state.user.userName);  // '' Modify by Felipe Pasillas 2024-02-21 to send user insted of using token
                    formData.append("file", me.file);  
                    
                   axios.post('api/dell_d_mod_file_master/UpdateDellMod',formData,configuration).then(function(response){                      
                        me.close();
                        //this.run_SAP();
                        me.listInvoices();
                        me.clean();
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,
                        //this.validaMensaje.push('Bom Upload.')
                    ); 

                   
                    //me.listInvoices();                                       

                } else {                    
                    //Code for Save                   
                   if (this.validar()){
                       return;
                   }                   

                    axios.defaults.baseURL =  this.$hostname;
                    let me=this;    
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token,
                        "Content-Type": "multipart/form-data"
                        };
                    let configuration = {headers : header };
                    this.dialogLoading = true;   

                    let formData = new FormData();                   
                    formData.append("project_name", me.project_name);
                    formData.append("file_name", '');
                    formData.append("status_file", '');
                    formData.append("created_by", this.$store.state.user.userName);  // '' Modify by Felipe Pasillas 2024-02-21 to send user insted of using token
                    formData.append("file", me.file);  

                   this.projectID_new = 0;
                   console.log('Project ID NEW=',this.projectID_new ) ;              
                   axios.post('api/dell_d_mod_file_master/CreateDellMod',formData,configuration).then(function(response){                      
                        me.close();
                        me.projectID_new = response.data.projectID; 
                        //this.run_SAP(); 
                        console.log('RETURN PROJECT ID = ' + me.projectID_new);                    
                        me.listInvoices();
                        me.clean();
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }                       
                       
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,                        
                    ); 


                    //me.listInvoices();                 
                }               
            },
           
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.project_name){
                     this.validaMensaje.push('Input the Project Name');
                 }   
                 if (this.file == null){
                     this.validaMensaje.push('Select the template file');
                 }
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>